module.exports = __webpack_public_path__ + "static/img/087.3cd1e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/087.png
// module id = BJmj
// module chunks = 0